"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sansSerifBoldItalic = void 0;
exports.sansSerifBoldItalic = {
  0x131: [.458, 0, .256],
  0x237: [.458, .205, .286]
};